import MotorbikesAPI from '../../api/motorbikes'

const store = {
  namespaced: true,
  state: () => ({
    motorbikes: [],
    motorbike: {}
  }),
  mutations: {
    set(state, motorbikes) {
      state.motorbikes = motorbikes
    },
    show(state, motorbike) {
      state.motorbike = motorbike
    }
  },
  actions: {
    async fetch(context) {
      const motorbikes = await MotorbikesAPI.list()
      context.commit('set', motorbikes)
    },
    async show(context, id) {
      const motorbike = await MotorbikesAPI.show(id)
      context.commit('show', motorbike)
    },
    async edit(context, {id, data}) {
      const motorbike = await MotorbikesAPI.edit(id, data)
      context.commit('show', motorbike)
    },
    async create(context, data) {
      const motorbike = await MotorbikesAPI.create(data)
      context.commit('show', motorbike)
    },
    async delete(context, id) {
      await MotorbikesAPI.delete(id)
      context.commit('show', {})
    }
  },
  getters: {
    motorbikes: state => {
      return state.motorbikes
    },
    motorbike: state => {
      return state.motorbike
    }
  }
}

export default store